module.exports = __webpack_public_path__ + "static/img/sjzxdd-DhhawDyN.86db1af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/sjzxdd-DhhawDyN.png
// module id = GxHI
// module chunks = 16